import { render, staticRenderFns } from "./template-3.vue?vue&type=template&id=5ca72698"
import script from "./template-3.vue?vue&type=script&lang=js"
export * from "./template-3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports